import React from 'react';

const SvgApproved = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1356_4302)">
        <path
          d="M10.3104 3.06135C11.6091 4.75767 11.7354 7.90565 9.49574 9.91365C7.38364 11.8078 4.14977 11.6731 2.18797 9.60718C0.234633 7.55038 0.274975 4.30024 2.28687 2.2929C4.38336 0.201619 7.491 0.411138 9.20554 1.87777C9.03246 2.04759 8.85873 2.21807 8.71558 2.35862C8.17747 2.13609 7.64001 1.82506 7.0622 1.69102C5.22339 1.26418 3.64614 1.78472 2.48989 3.27933C1.32712 4.7824 1.18397 6.46115 2.10078 8.12884C3.01498 9.79197 4.49267 10.5825 6.39396 10.427C9.50941 10.1713 11.3756 6.86262 9.99807 4.0621C9.84581 3.75237 9.86012 3.55457 10.0853 3.33073C10.1666 3.25005 10.2343 3.1544 10.311 3.06135H10.3104Z"
          fill="#0081FF"
        />
        <path
          d="M5.09906 6.33161C6.37439 5.11224 7.63215 3.9202 8.8769 2.71514C9.45275 2.15816 10.0065 1.57776 10.5641 1.00191C10.7365 0.823619 10.9194 0.727319 11.1276 0.906906C11.3339 1.08519 11.2727 1.28235 11.1217 1.4795C9.24843 3.9189 7.37838 6.36089 5.50573 8.80029C5.23114 9.15816 4.993 9.1471 4.74574 8.76515C4.14516 7.83793 3.54784 6.90942 2.95377 5.97829C2.74946 5.65881 2.77353 5.32371 3.00192 5.08296C3.2713 4.79861 3.64154 4.78951 3.91287 5.07255C4.33971 5.51761 4.75875 5.96984 5.09906 6.33161Z"
          fill="#0081FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_1356_4302">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgApproved;
